import type { AssistantEmailPreview } from '@services/modules/AssistantStream'

import { KW } from '../ui/theme'

/**
 * An email on a confirmation card, laid out as the recipient will read it: To and Subject on
 * top, then the body's paragraphs with space between them (line breaks inside a paragraph kept).
 */
const EmailPreview = ({ email }: { email: AssistantEmailPreview }) => (
  <div
    className="my-2 overflow-hidden rounded-[8px] text-[12.5px]"
    style={{ border: `1px solid ${KW.line2}` }}
    aria-label="Email preview"
  >
    <div
      className="px-3 py-2"
      style={{ background: KW.soft2, borderBottom: `1px solid ${KW.line2}` }}
    >
      <div className="flex gap-2">
        <span className="w-[54px] shrink-0" style={{ color: KW.muted }}>
          To
        </span>
        <span style={{ color: KW.ink }}>{email.to}</span>
      </div>
      <div className="mt-[2px] flex gap-2">
        <span className="w-[54px] shrink-0" style={{ color: KW.muted }}>
          Subject
        </span>
        <span className="font-semibold" style={{ color: KW.ink }}>
          {email.subject}
        </span>
      </div>
    </div>
    <div
      className="flex flex-col gap-3 px-3 py-3 leading-[1.55]"
      style={{ color: KW.body }}
    >
      {(email.body ?? []).map((paragraph, index) => (
        <p key={index} className="m-0 whitespace-pre-line">
          {paragraph}
        </p>
      ))}
    </div>
  </div>
)

export default EmailPreview
